module.exports = __webpack_public_path__ + "static/media/dice-three.3b11218d.svg";